import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9995)">
      <g clip-path="url(#clip1_5438_9995)">
        <path
          d="M0.0800781 11.96C0.0800781 18.5653 5.43475 23.92 12.0401 23.92C18.6454 23.92 24.0001 18.5653 24.0001 11.96C24.0001 5.35468 18.6454 0 12.0401 0C5.43475 0 0.0800781 5.35468 0.0800781 11.96Z"
          fill="#F30019"
        />
        <path
          d="M12.0392 9.30327L15.6965 15.483H8.38269L12.04 9.30327M12.04 4.56091L4.04004 18.0791H20.04L12.0392 4.56091H12.0403H12.04Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5438_9995">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_5438_9995">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
